module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av16-a48fdbcbb29f19b15fcbd5a243c050fe.jpg";